export type HomeLandingFaqItem = {
  question: string;
  answer: string;
};

export const HOME_LANDING_CONTENT = {
  about: {
    heading: 'About',
    body: 'NBNA connects and empowers local businesses in Nanaimo through networking, support, and growth opportunities.',
    cta: {
      label: 'Attend Next Meeting',
    },
  },
  faq: {
    heading: 'FAQ',
    items: [
      {
        question: 'Who can attend a meeting?',
        answer: 'Guests are welcome to request an invite to attend the next meeting and learn about NBNA.',
      },
      {
        question: 'What happens at a meeting?',
        answer: 'Members network, share referrals, and support each other’s business growth.',
      },
    ] satisfies HomeLandingFaqItem[],
  },
  howToJoin: {
    heading: 'How to Join',
    body: 'Request to attend a meeting, meet members, then apply for membership.',
    industriesSought: [
      'Accounting / Bookkeeping',
      'Legal',
      'Mortgage / Real Estate',
      'Insurance',
      'Trades (Electrical, Plumbing, HVAC)',
      'Marketing / Web',
    ],
  },
} as const;
